import FwBookblock2 from "./bookblock2.vue";
import { pluginFactory } from "../../utils/plugin";

const Bookblock2Plugin = pluginFactory({ components: { FwBookblock2 } });

export { Bookblock2Plugin, FwBookblock2 };
